import axiosInstance from '@/services/axiosInstance'

async function getFilter1 (groupId, categoryId, siteId, startDate, endDate, data) {
  const req = {
    url: `filter/filtro1/${groupId}/${categoryId}/${siteId}/${startDate}/${endDate}`,
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data
}

async function getFilter2 (groupId, categoryId, siteId, startDate, endDate, data) {
  const req = {
    url: `filter/filtro2/${groupId}/${categoryId}/${siteId}/${startDate}/${endDate}`,
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data
}

async function getFilter3 (groupId, categoryId, siteId, startDate, endDate, data) {
  const req = {
    url: `filter/filtro3/${groupId}/${categoryId}/${siteId}/${startDate}/${endDate}`,
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data
}

async function getFilter4 (groupId, categoryId, siteId, startDate, endDate, data) {
  const req = {
    url: `filter/filtro4/${groupId}/${categoryId}/${siteId}/${startDate}/${endDate}`,
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data
}

async function getFilter5 (groupId, categoryId, siteId, startDate, endDate, data) {
  const req = {
    url: `filter/filtro5/${groupId}/${categoryId}/${siteId}/${startDate}/${endDate}`,
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data
}

async function getFilter6 (groupId, categoryId, siteId, startDate, endDate, data) {
  const req = {
    url: `filter/filtro6/${groupId}/${categoryId}/${siteId}/${startDate}/${endDate}`,
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data
}

async function getFilter7 (groupId, categoryId, siteId, startDate, endDate, data) {
  const req = {
    url: `filter/filtro7/${groupId}/${categoryId}/${siteId}/${startDate}/${endDate}`,
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data
}

async function getFilter8 (groupId, categoryId, siteId, startDate, endDate, data) {
  const req = {
    url: `filter/filtro8/${groupId}/${categoryId}/${siteId}/${startDate}/${endDate}`,
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data
}

async function getFilter9 (groupId, categoryId, siteId, startDate, endDate, data) {
  const req = {
    url: `filter/filtro9/${groupId}/${categoryId}/${siteId}/${startDate}/${endDate}`,
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data
}

async function getFilter10 (groupId, categoryId, siteId, startDate, endDate, data) {
  const req = {
    url: `filter/filtro10/${groupId}/${categoryId}/${siteId}/${startDate}/${endDate}`,
    method: 'POST',
    data
  }

  const res = await axiosInstance(req)

  return res.data
}

export { getFilter1, getFilter2, getFilter3, getFilter4, getFilter5, getFilter6, getFilter7, getFilter8, getFilter9, getFilter10 }
